module.exports = __webpack_public_path__ + "9c9342d78a630f7a69b1cb33c0b8dda2.svg";